export default __webpack_public_path__ + "static/media/buyHome.d89a9e5d.png";